/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/*!*******************!*\
  !*** ./es-faq.ts ***!
  \*******************/


//es-faq
(function () {
  var rootEls = document.querySelectorAll('[data-es-faq]');
  if (!rootEls.length) return;
  rootEls.forEach(rootEl => rootEl.addEventListener('click', e => {
    if (e.target.hasAttribute('data-es-faq-question')) {
      e.stopImmediatePropagation();
      var expanded = 'true' === e.target.getAttribute('aria-expanded');
      var index = e.target.getAttribute('data-es-faq-question');
      var answerEl = rootEl.querySelector("[data-es-faq-answer=\"".concat(index, "\"]"));
      var iconEl = rootEl.querySelector("[data-es-faq-icon=\"".concat(index, "\"]"));
      if (!answerEl) return;
      e.target.setAttribute('aria-expanded', !expanded);
      answerEl.setAttribute('aria-hidden', expanded.toString());
      if (answerEl.classList.contains('es-hidden')) {
        var _e$target;
        (iconEl === null || iconEl === void 0 ? void 0 : iconEl.style) && (iconEl.style.transform = 'rotate(180deg)');
        ((_e$target = e.target) === null || _e$target === void 0 || (_e$target = _e$target.parentNode) === null || _e$target === void 0 ? void 0 : _e$target.hasAttribute('data-grid-item')) && (e.target.parentNode.style.height = "100%");
        answerEl.classList.remove('es-hidden');
      } else {
        var _e$target2;
        (iconEl === null || iconEl === void 0 ? void 0 : iconEl.style) && (iconEl.style.transform = 'rotate(0deg)');
        ((_e$target2 = e.target) === null || _e$target2 === void 0 || (_e$target2 = _e$target2.parentNode) === null || _e$target2 === void 0 ? void 0 : _e$target2.hasAttribute('data-grid-item')) && (e.target.parentNode.style.height = "min-content");
        answerEl.classList.add('es-hidden');
      }
    }
  }));
})();
/******/ })()
;